// import './style.scss'
import {Row , Col} from '../grid'
import { Label } from '../form'

export const Search = {
  name:'Search',
  provide() {
    return {
      layout: this.layout
    }
  },
  props:{
    //不填自适应
    col:{
      type:Number
    },
    showCount:{
      type:Number,
      default:4,
    },
    inlineAction:{
      default:true
    }
  },
  computed:{
    layout(){
      return { 
        xs:24 , sm:12 , md:12 , lg:8 , xl:Math.round(24/this.col) , xxl:Math.round(24/this.col)
      }
    }
  },
  data(){
    return {
      showMore:false,
    }
  },
  methods:{
    renderAction( count = 0){
      const { col , showMore , $scopedSlots , showCount } = this;
      const action = $scopedSlots.action ? $scopedSlots.action() : null

      const actionEl = [
        <i-button type="primary" icon="ios-search" on-click={this.onSearch}>搜索</i-button>,
        <i-button style="margin-left: 8px" on-click={this.onReset}>重置</i-button>
      ]

      //let showCount = this.showCount ? this.showCount : col
      let expand = count > showCount

      if( expand ){
        actionEl.push(
          <a on-click={this.toggle} style="margin-left: 8px">
            { showMore ? '收起' : '展开' }
            <Icon type={showMore ? 'up' : 'down'}/>
          </a>
        )
      }

      const layout = {...this.layout }

      let contentcol = count 
      if( expand && !showMore ) contentcol = showCount// - 1

      const actionWrap = <div style="flex:none;">{actionEl}</div>
      const customWrap = action ? <div style="flex:none;">{action}</div> : null

      if(this.inlineAction == false){
        for(let i in layout ){
          layout[i] = 24 - layout[i] * contentcol % 24
        }
        return [
          <Col {...{props:{...layout}}} style="margin-bottom:8px;">
            {actionEl}
          </Col>,
          <Col span={24}>
            {action}
          </Col>
        ]
      }else{
        //操作位占据剩余空间 e.g. col=4 , showCount=6 , 则
        // xs:24 , sm:12 , md:12 , lg:8 , xl:6 , xxl:6
        // adjustCol = 24 / layout[i]
        // restCol = ( showCount % adjustCol )
        // newLayout[i] = restCol * layout[i]

        for(let i in layout ){
          // layout[i] = ( showCount % (24 / layout[i]) ) * layout[i]
          layout[i] = 24 - layout[i] * contentcol % 24
        }
        return <Col {...{props:{...layout}}}>
          <div style="margin-bottom:8px;display:flex;justify-content:space-between;    flex-wrap: wrap;">
            {actionWrap}
            {customWrap}
          </div>
        </Col>
      }
    },
    onSearch(){
      this.$emit('search')
    },
    onReset(){
      this.$emit('reset')
    },
    toggle(){
      this.showMore = !this.showMore
    }
  },
  render() {
    const { $scopedSlots , col , showMore , showCount } = this;
    const children = $scopedSlots.default ? $scopedSlots.default() : []
    const expand = children.length > showCount
    const vnode = (!expand || showMore) ? children : children.filter((_,idx) => idx < showCount)
    const actionEl = this.renderAction(children.length)
    return (
      <div class="list-filter">
        <Row gutter={16}>
          {vnode}
          {actionEl}
        </Row>
      </div>
    );
  },
}

export const SearchItem = {
  name:'SearchItem',

  inject: {
    layout: {
      default: () => {
        return {xs:24, sm:24 , md:8 , lg:6 , xl:6 , xxl:6}
      }
    }
  },
  props:{
    title:''
  },
  render() {
    const { $scopedSlots , title , layout } = this;
    return (
      <Col {...{props:layout}}>
        <Label title={title}>
          { $scopedSlots.default ? $scopedSlots.default() : null }
        </Label>
      </Col>
    );
  },
}

export const ComboItem = {
  name:'SearchItemCombo',
  props:{
    divider:{
      default:'~'
    }
  },
  render() {
    const { $slots , layout , divider} = this;
    const insert = <span class="sl-search-combo-divider"> {divider} </span>
    const vnode = $slots.default
    return (
      <span class="sl-search-combo">
        {vnode.reduce((t,c,idx,arr)=>t.concat(idx > 0 ? [insert , c] : [c]),[])}
      </span>
    );
  },
}